import {connect, MapDispatchToProps, MapStateToProps, WithStore} from "../../redux/services/Imports";
import Content from "../Content/Content";
import Title from "../Title/Title";
import CardCount from "../CardCount/CardCount";
import React from "react";
import {ITextCards} from "../../redux/initState/InterfacesState";

interface Props {
  textCards: ITextCards;
  heightLazy: number | null;
}

export const BlockTextCards = ({textCards, heightLazy}: Props)  => {
  if (!textCards.title && (!textCards.items || !textCards.items.length)) {
    return <></>;
  }
  return (
    <Content
      heightLazy={heightLazy}
      padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
      block={
        <>
          <Title center title={textCards.title} />
          <div className="page-return-documents__grid-4">
            {textCards.items.map(({text}, i) => (
              <CardCount idx={i + 1} numberCard={i + 1} text={text} noCut height="auto" key={i} />
            ))}
          </div>
        </>
      }
    />
  )
}

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(BlockTextCards));
